module.exports = __webpack_public_path__ + "img/B2B.4feac449.jpg";